import Searchbox from "../../component/Searchbox/Searchbox";
import Search from "../../component/search/Search";
import Product from "../../component/product/Product";
import './store.css'

export default function Store(props) {
    function title() {
        document.title = 'تهران مو | محصولات'
      }
      title()
    return(
        <div className="storepage">
            <Search language={props.language} searching={props.searching} opensearch={props.opensearch} setOpensearch={props.setOpensearch}/>
            <Product cart={props.cart} setCart={props.setCart} addToCart={props.addToCart}/>
            <Searchbox searchvalue={props.searchvalue} opensearch={props.opensearch} setOpensearch={props.setOpensearch}/>
        </div>
    )
}